import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { AppHeader } from "~/components/layout/app-header";
import { CreateProjectForm } from "~/components/projects/create-project-form";
import { Button } from "~/components/ui/button";

export const Route = createFileRoute("/_auth/projects/new")({
  head: () => ({
    meta: [{ title: "New Project | Canopy" }],
  }),
  component: NewProjectPage,
});

function NewProjectPage() {
  const { user } = Route.useRouteContext();

  return (
    <>
      <AppHeader userName={user.name} userEmail={user.email} userImage={user.image} />
      <main className="mx-auto w-full max-w-2xl px-6 py-8">
        <div className="animate-fade-in-up">
          <Button
            variant="ghost"
            size="sm"
            render={<Link to="/dashboard" />}
            className="text-muted-foreground -ml-2 gap-1.5"
            nativeButton={false}
          >
            <ArrowLeft className="size-4" />
            Back to Dashboard
          </Button>
          <h1 className="text-foreground mt-4 text-xl font-semibold">Create a new project</h1>
          <p className="text-muted-foreground mt-1 text-sm">
            Set up a systematic review project to organize your research and screen citations.
          </p>
        </div>

        <div className="stagger-1 mt-8">
          <CreateProjectForm />
        </div>
      </main>
    </>
  );
}
